import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationOptionLabel from '../../../../../fulfillment-planner/confirmation-option/label';
import ConfirmationOptionContainer from '../../../../../fulfillment-planner/confirmation-option/container';

import style from './style.module.less';

const Confirmation = ({ fulfillmentPlanId }) => {
  return (
    <React.Fragment>
      <div className={style.label}>
        <ConfirmationOptionLabel />
      </div>
      <ConfirmationOptionContainer className={style.confirmation} fulfillmentPlanId={fulfillmentPlanId} />
      <div />
    </React.Fragment>
  );
};

Confirmation.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default Confirmation;
